import { useTranslation } from "react-i18next";
import InfoBlock from "../InfoBlock/InfoBlock";
import { MdEdit, MdFilterAltOff } from "react-icons/md";
import { ICON_SIZES } from "../../helpers/constants";
import useMobile from "../../hooks/useMobile";
import useMainFilter from "../../hooks/useMainFilter";
import SlideDownUpAnimation from "../Animations/SlideDownUpAnimation";
import { EButtonKind } from "../Button/ButtonTypes";
import { memo } from "react";

interface IActiveMainFilterMessage {
  onShowSearch: () => void;
}

const ActiveMainFilterMessage: React.FC<IActiveMainFilterMessage> = ({
  onShowSearch,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { setMainFilter, isMainFilterActive } = useMainFilter();

  return (
    <SlideDownUpAnimation show={isMainFilterActive}>
      <InfoBlock
        message={t("shared.showing_filtered_results")}
        buttons={[
          {
            icon: <MdEdit size={ICON_SIZES.MD} />,
            onClick: () => onShowSearch(),
            tooltip: t("shared.edit_filter"),
            kind: EButtonKind.EDIT,
          },
          {
            text: isMobile ? "" : t("shared.remove_filter"),
            kind: EButtonKind.DANGER,
            icon: <MdFilterAltOff size={ICON_SIZES.MD} />,
            onClick: () => {
              setMainFilter({
                dateFrom: "",
                dateTo: "",
                type: "",
                payTo: [],
                status: [],
                paymentMethod: [],
                tags: [],
                category: [],
              });
            },
          },
        ]}
      />
    </SlideDownUpAnimation>
  );
};

export default memo(ActiveMainFilterMessage);
